import { Modal } from '@/ui/Modal'
import { Button } from '@/ui/Button'
import { useModal } from '@/components/Modal'
import styles from './AddRouteModal.module.scss'

export type Props = {
    title: string | React.ReactNode
    message: string | React.ReactNode
    onAddRoute: () => void
    onCancel: () => void
}

export const AddRoute = () => {
    const { closeModal, props } = useModal<Props>()

    const handleAddRoute = () => {
        if (!props) {
            return
        }

        props.onAddRoute()
        closeModal()
    }

    const handleCancel = () => {
        if (!props) {
            return
        }
        props.onCancel()
        closeModal()
    }

    if (!props) {
        return null
    }

    return (
        <Modal className={styles.modal} onClose={closeModal} hideCloseButton>
            <div className={styles.information}>
                <h1 className={styles.title}>{props.title}</h1>
                <p className={styles.description}>{props.message}</p>
            </div>
            <div className={styles.footer}>
                <Button rounded variant="tertiary" onClick={handleCancel}>
                    Delete disruption
                </Button>
                <Button rounded variant="secondary" onClick={handleAddRoute}>
                    Add route
                </Button>
            </div>
        </Modal>
    )
}
